import { Component, EventEmitter, Inject, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'app/core/services/data.service';
import { PrivateService } from 'app/core/services/private.service';
import { EmployeeSchedule } from 'app/shared/models/employeeSchedule';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'dialog-workdays',
  templateUrl: './dialog-workdays.component.html',
  styleUrls: ['./dialog-workdays.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogWorkdaysComponent implements OnInit {

  scheduleForm: FormGroup;

  weekdays: { value: number, name: string }[] = [
    { value: 0, name: 'Sunday' },
    { value: 1, name: 'Monday' },
    { value: 2, name: 'Tuesday' },
    { value: 3, name: 'Wednesday' },
    { value: 4, name: 'Thursday' },
    { value: 5, name: 'Friday' },
    { value: 6, name: 'Saturday' }
  ];

  isLoading: boolean = false;
  isLoadingDelete: boolean = false;

  @Output() submissionSuccess: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public dialogRef: MatDialogRef<DialogWorkdaysComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private privateService: PrivateService,
    private fb: FormBuilder,
    private dataService: DataService,
    private toastr: ToastrService
    // ✅ REMOVED: DialogEmployeeDetailsService — no longer needed here
  ) {
    this.scheduleForm = this.fb.group({
      employeeName: [{ value: data.employeeName, disabled: true }],
      payrollPeriod: [{ value: data.payrollPeriod, disabled: true }],
      weekDay: [''],
      isRestDay: [],
      isCustomWorkday: [],
      customWorkdayDate: [''],
      validFrom: [''],
      validTo: [''],
      rampTime1: [''],
      rampTime2: [''],
      rampTime3: [''],
      rampTime4: [''],
      rampTime5: [''],
      rampTime6: ['']
    });

    this.scheduleForm.get('isCustomWorkday')?.valueChanges.subscribe(value => {
      const customWorkdayDateControl = this.scheduleForm.get('customWorkdayDate');
      if (value) {
        customWorkdayDateControl?.setValidators([Validators.required]);
      } else {
        customWorkdayDateControl?.clearValidators();
      }
      customWorkdayDateControl?.updateValueAndValidity();
    });
  }

  ngOnInit(): void { }

  onNoClick(): void {
    // ✅ FIX: just close — do NOT open employee details dialog
    this.dialogRef.close(false);
  }

  onSubmit(formGroup: FormGroup): void {
    this.isLoading = true;
    const formValues = formGroup.value as EmployeeSchedule;

    this.privateService.insertSchedule(formValues, this.data.employeeID, this.data.payrollID).subscribe({
      next: () => {
        this.dataService.callToggle.next(true);
        setTimeout(() => { this.isLoading = false; }, 1000);
        this.dialogRef.close(true);
      },
      error: (err) => {
        console.error(err);
        setTimeout(() => { this.isLoading = false; }, 1000);
        this.showErrorNotification('Error inserting schedule.');
      }
    });
  }

  deleteSchedule(): void {
    this.isLoadingDelete = true;
    this.privateService.deleteSchedule(this.data.employeeWorkDaysID).subscribe({
      next: () => {
        this.dataService.callToggle.next(true);
        setTimeout(() => { this.isLoadingDelete = false; }, 1000);

        // ✅ FIX: just close with true so the caller (deleteScheduleForDay /
        //         deleteCustomWorkday) knows to refresh — no modal opened here
        this.dialogRef.close(true);
      },
      error: (err) => {
        console.error(err);
        setTimeout(() => { this.isLoadingDelete = false; }, 1000);
        this.showErrorNotification('Error deleting schedule.');
      }
    });
  }

  showErrorNotification(text: string): void {
    this.toastr.success(
      `<span class="now-ui-icons ui-1_bell-53"></span> ${text}`, '',
      {
        timeOut: 3000,
        closeButton: true,
        enableHtml: true,
        toastClass: 'alert alert-danger alert-with-icon',
        positionClass: 'toast-top-center'
      }
    );
  }
}